import {
  FETCH_IRC_LIST_REQUEST,
  FETCH_IRC_LIST_SUCCESS,
  FETCH_IRC_LIST_ERROR,
  SAVE_IRC_LIST_REQUEST,
  DELETE_IRC_LIST_REQUEST,
  SAVE_IRC_LIST_SUCCESS,
  DELETE_IRC_LIST_SUCCESS,
  DELETE_IRC_LIST_ERROR,
  SAVE_IRC_LIST_ERROR,
  SAVE_IRC_LIST_RESET_ERROR,
  INVENTORY_CRITERIA_VALIDATE_PRODUCTS_BEFORE,
  INVENTORY_CRITERIA_VALIDATE_PRODUCTS_SUCCESS,
  INVENTORY_CRITERIA_VALIDATE_PRODUCTS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
  },
  save: {
    record: {},
    error: null,
    isFetching: false,
  },
  productsValidation: {
    error: null,
    validated: {},
  },
}

const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_IRC_LIST_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_IRC_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload.data,
        },
        productsValidation: {
          error: null,
          validated: {},
        },
      }

    case FETCH_IRC_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: action.payloadlabel,
        },
      }

    case DELETE_IRC_LIST_REQUEST:
    case SAVE_IRC_LIST_REQUEST:
      return {
        ...state,
        save: {
          ...state.save,
          isFetching: true,
        },
      }

    case DELETE_IRC_LIST_SUCCESS:
    case SAVE_IRC_LIST_SUCCESS:
      return {
        ...state,
        save: {
          ...state.save,
          isFetching: false,
          error: null,
          record: action.payload,
        },
      }

    case DELETE_IRC_LIST_ERROR:
    case SAVE_IRC_LIST_ERROR:
      return {
        ...state,
        save: {
          ...state.save,
          isFetching: false,
          record: {},
          error: action.payload,
        },
      }

    case SAVE_IRC_LIST_RESET_ERROR:
      return {
        ...state,
        save: {
          error: null,
        },
      }

    case INVENTORY_CRITERIA_VALIDATE_PRODUCTS_BEFORE:
      return {
        ...state,
        productsValidation: {
          error: null,
          validated: {},
        },
      }

    case INVENTORY_CRITERIA_VALIDATE_PRODUCTS_SUCCESS:
      return {
        ...state,
        productsValidation: {
          error: null,
          validated: action.payload,
        },
      }

    case INVENTORY_CRITERIA_VALIDATE_PRODUCTS_ERROR:
      return {
        ...state,
        productsValidation: {
          error: action.payload,
          validated: {},
        },
      }

    default:
      return state
  }
}

export default reducer
